
import { useEffect } from "react";
import { AddUpdate, getData, getPostData, getPostDatas } from "../../ApiMethods/ApiMethods";
import {
    ADD_CUSTOMER_STORY,
    Astro_Data,
    CelebritiesVids_Data,
    Contact_Data,
    DELETE_CUSTOMER_STORY,
    TaskData_Array,
    UPDATE_CUSTOMER_STORY,
    InquiryAction_Data,
    BankDetails_Data,
    SET_ASTRO_ID,
    BankDetailsSingle_Data,
    AstrologerSingle_Data,
    InquiryAction_User,
    QualificationDrp_Data,
    DregeeDiplomaDrp_Data,
    HoroScopeName_Data,
    Horo_Data,
    HoroScopeSingle_Data,
    Slider_Data,
    SliderSingle_Data,
    Wallet_Data,
    WalletSingle_Data,
    SkillsList_Data,
    SkillsListSingle_Data,
    LanguagesList_Data,
    LanguagesListSingle_Data,
    BlogCategory_Data,
    BlogCategorySingle_Data,
    DregeeDiplomaSingle_Data,
    DregeeDiploma_Data,
    Skills_Data,
    Languages_Data,
    AstrologersCategorySingle_Data,
    AstrologersCategory_Data,
    Blog_Data,
    BlogSingle_Data,
    BlogCategoryDrp_Data,
    PrivacyPolicy_Data,
    PrivacyPolicySingle_Data,
    PrivacyPolicyDrop_Data,
    CategoryNotification_Data,
    CategoryNotification_Single_Data,
    DataNotification_Data,
    PushCategoryDrp_Data,
    SET_DROPDOWN_DATA,
    PushCategory_Single_Data,
    Pooja_Data,
    Pooja_Single_Data,
    Puja_Get_Data_Puja,
    PujaFor_GetDropDownData_PujaFor,
    Puja_GetSinglaData_Puja,
    SET__Puja_ID,
    SET__GemstoneOrderID,
    Gemstone_Category_data,
    GemstoneCategory_Singledata,
    Gemstone_GetData_GemData,
    GemstoneCategory_GetDropDawnData,
    Gemstone_Singledata,
    Gemstone_User,
    Gemstone_Order_List,
    Gemstone_Cart_List,
    SinglaData_GemstoneOrder,
    Call_History,
    SET_DROPDOWN_ASTRO,
    CAll_CHART_DATA,
    Home_Page_Count,
    User_Filter,
    Chat_Acc_Day,
    Astro_Filter,
    Expense_Category,
    Single_Expense_Category,
    Income_Category,
    SinglaData_IncomeCategory,
    Ticket_Category,
    SinglaData_Ticket_Category,
    Chat_Filter,
    Online_Puja_Filter,
    Gemstone_Filter,
    Call_Filter,
    User_Status,
    Total_Astrologer,
    Chat_Chart,
    Gemstone_Revenue,
    Pooja_Revenue,
    Call_Revenue,
    User_list,
    User_Insert,
    GetData_Users,
    AdminSingle_Data,
    Insert_ExpenseCategory,
    Update_ExpenseCategory,
    Delete_ExpenseCategory,
    Expense_Details,
    Single_Expense_Details,
    Insert_Expense_Details,
    Update_Expense_Details,
    Delete_Expense_Details,
    GetDropDownData_ExpenseCategory,
    GetData_Muhurat,
    GetSinglaData_Muhurat,
    GetDropDwonData_Muhurat,
    GetData_MainMuhurat,
    GetSinglaData_MainMuhurat,
    GetData_TransactionCategory,
    GetSingleData_TransactionCategory,
    GetDropDownData_TransactionCategory,
    GetData_VratUpvaas,
    GetSinglaData_VratUpvaas,
    GetDropDwonData_MainVratUpvaas,
    GetData_MainVratUpvaas,
    GetSinglaData_MainVratUpvaas,
    GetData_CompanyTransaction,
    GetSingleData_CompanyTransaction,
    GetData_PaymentHistory, GetData_UserWalletTransaction, GetData_AstroWalletTransaction,
    Chat_Message,
    GetData_headerCompanyTransaction,
    GetsinglaData_Company,
    GetData_Company,
    GetData_Paymentbutnotbuy,
    GetData_PaymentchangeRequest,
    GetData_AstrologerGallery,
    GetSinglaData_AstrologerGallery,
    GetData_Feedback,
    GetSingleData_Feedback,
    GetData_UserNotUsed,
    GetSinglaData_PaymentchangeRequest,
    GetData_Festival,
    GetSinglaData_Festival,
    GetData_NotificationRule,
    GetSinglaData_NotificationRule,
    CategoryRedirect,
    CategoryRedirectsingle,
    CategoryCondition,
    AuthorName,
    AuthorNameSingle_Data,
    Categorys_Data,
    GetData_PackageRoles,
    GetSinglaData_PackageRoles,
    GetData_Expense,
    GetSinglaData_Expense,
    GetData_ChatAnalysisReport,
    GetData_WalletPlanName,
    GetsinglaData_WalletPlanName,
    SinglaData_User,
    GetData_AstroSallaryTransaction,
} from "../Action_Types";
import CryptoJS from "crypto-js";
import { Package, User } from "lucide-react";
 
export const insert_LocalStoreData = (formData, Tokens) => async (dispatch) => {
   
};


   
export const get_CustomerStoriesData = (IsActive) => async (dispatch) => {
    const val = { 'IsActive': IsActive }
    const res = await getPostData('CustomerStories/ ', val)
    dispatch({ type: TaskData_Array, payload: res });
};

export const get_CelebritiesData = (IsActive) => async (dispatch) => {
    const val = { 'IsActive': IsActive }
    const res = await getPostData('CelebritiesVideos/GetData_CelebritiesVideos', val)
    dispatch({ type: CelebritiesVids_Data, payload: res });
};


export const get_ContactData = (setloading, Status) => async (dispatch) => {
    setloading(true)
    const val = { 'Status': Status };
    const res = await getPostData('Inquiry/GetData_Inquiry', val);
    dispatch({ type: Contact_Data, payload: res });
    setloading(false)
};



export const get_AstroData = ( IsActive, CreatedFrom, CreatedTo, Name, Mobileno, location,IsVerified) => async (dispatch) => {
   
   const val = { IsActive: IsActive, CreatedFrom: CreatedFrom, CreatedTo: CreatedTo, DisplayName: Name, RegMobileNo: Mobileno, CurrentAddress: location,IsVerified:IsVerified }

    const res = await getPostData('Astrologer/GetData_Astrologer', val)
   
    dispatch({ type: Astro_Data, payload: res });
    
};

export const get_UserData = (setloading, IsActive, CreatedFrom, CreatedTo, Name, Mobileno, location,UserID) => async (dispatch) => {
    setloading(true)
    const val = { 
        
         CreatedFrom: CreatedFrom, CreatedTo: CreatedTo, NickName: Name, MobileNo: Mobileno, CurrentAddress: location,UserID:UserID }

    const res = await getPostData('User/GetData_User', val)
    dispatch({ type: User_list, payload: res });
    setloading(false)
};

export const get_UserSingleData = (ID) => async (dispatch) => {
    const val = { 'UserID': ID }
    const res = await getPostData('User/GetSingleData_User', val)
    dispatch({ type: SinglaData_User, payload: res });
};


export const get_InquiryUserData = () => async (dispatch) => {
    const res = await getPostData('InquiryAction/GetDataDropDown_User');

    if (res) {

        const formattedData = res.map(item => ({
            value: item.ID,
            label: item.FullName
        }));
        dispatch({ type: InquiryAction_User, payload: formattedData });
    } else {
        dispatch({ type: InquiryAction_User, payload: res });
    }
};



export const get_InquiryAction = () => async (dispatch) => {
    const res = await getPostData('InquiryAction/GetDataDropDown_InquiryStatus');

    if (Array.isArray(res)) {

        const formattedData = res.map(item => {

            return {

                value: item.Description,
                label: item.Description
            };
        });

        dispatch({ type: InquiryAction_Data, payload: formattedData });
    } else {
        dispatch({ type: InquiryAction_Data, payload: [] });
    }
};

export const Comman_changeArrayFormat = (data, Id, Description, FullName) => {
    if (!Array.isArray(data)) return [];

    return data.map((item) => ({
        id: item[Id] || null,
        label: item[Description] || item[FullName],
        FullName: item[FullName] || null
    }));
};



   
export const get_LocalStoreData = (UniqueId) => async (dispatch) => {
    
};




export const get_BankDetailsData = (ID, IsActive) => async (dispatch) => {
    const val = { 'AstroID': ID, 'IsActive': IsActive }
    const res = await getPostData('BankDetails/GetData_BankDetails', val)
    dispatch({ type: BankDetails_Data, payload: res });
};

export const get_BankDetailsSingleData = (BankDetailsID) => async (dispatch) => {
    const val = { 'BankDetailsID': BankDetailsID }
    const res = await getPostData('BankDetails/GetSingleData_BankDetails', val)
    dispatch({ type: BankDetailsSingle_Data, payload: res });
};

export const get_AstrologerSingleData = (AstrologerID) => async (dispatch) => {
    const val = { 'AstrologerID': AstrologerID }
    const res = await getPostData('Astrologer/GetSingleData_Astrologer', val)
    dispatch({ type: AstrologerSingle_Data, payload: res });
};


export const get_Qualification = () => async (dispatch) => {
    const res = await getData('Astrologer/GetDropDownData_Qualification');
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return { value: item.QualificationID, label: item.Description };
        });
        dispatch({ type: QualificationDrp_Data, payload: formattedData });
    } else {
        dispatch({ type: QualificationDrp_Data, payload: [] });
    }
};

export const get_DregeeDiploma = () => async (dispatch) => {
    const res = await getData('Astrologer/GetDropDownData_DregeeDiploma');
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return { value: item.DregeeID, label: item.Description };
        });
        dispatch({ type: DregeeDiplomaDrp_Data, payload: formattedData });
    } else {
        dispatch({ type: DregeeDiplomaDrp_Data, payload: [] });
    }
};



export const get_HoroscopeData = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
   
     const res = await getPostData('HoroscopeDetails/GetData_HoroscopeDetails', val)
    dispatch({ type: Horo_Data, payload: res });
    setloading(false)
};

export const get_HoroScopeSingleData = (ID) => async (dispatch) => {
    const val = { 'ID': ID }
  
     const res = await getPostData('HoroscopeDetails/GetSingleData_HoroscopeDetails', val)
    dispatch({ type: HoroScopeSingle_Data, payload: res });
};

export const get_HoroNameDrpData = () => async (dispatch) => {
    const res = await getData('Horoscope/GetDropDownData_HoroscopeType');
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.ID, label: item.Name
            };
        });
        dispatch({ type: HoroScopeName_Data, payload: formattedData });
    } else {
        dispatch({ type: HoroScopeName_Data, payload: [] });
    }
};



export const get_SliderData = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('HomePagesliders/GetData_HomePagesliders', val)
    dispatch({ type: Slider_Data, payload: res });
    setloading(false)
};

export const get_SliderSingleData = (HomePageslidersID) => async (dispatch) => {
    const val = { 'HomePageslidersID': HomePageslidersID }
    const res = await getPostData('HomePagesliders/GetSingleData_HomePagesliders', val)
    dispatch({ type: SliderSingle_Data, payload: res });
};



export const get_WalletData = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
  
     const res = await getPostData('WalletPackage/GetSingleData_WalletPackage', val)
    dispatch({ type: Wallet_Data, payload: res });
    setloading(false)
};

export const get_WalletSingleData = (WalletPackageID) => async (dispatch) => {
    const val = { 'WalletPackageID': WalletPackageID }
    const res = await getPostData('WalletPackage/GetSingleData_WalletPackage', val)
    dispatch({ type: WalletSingle_Data, payload: res });
};

    


export const get_PackageRoles=(IsActive,setloading)=>async(dispatch)=>{
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('PackagesRules/GetData_PackagesRules', val)
    dispatch({ type: GetData_PackageRoles, payload: res });
    setloading(false)
}

export const get_SinglePackageRoles = (OfferId) => async (dispatch) => {
    const val = { 'OfferId': OfferId }
    const res = await getPostData('PackagesRules/GetSinglaData_PackagesRules', val)
    dispatch({ type: GetSinglaData_PackageRoles, payload: res });
};





export const get_SkillsListData = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('lstSkills/GetData_Skills', val)
    dispatch({ type: SkillsList_Data, payload: res });
    setloading(false)
};

export const get_SkillsListSingleData = (SkillsID) => async (dispatch) => {
    const val = { 'SkillsID': SkillsID }
    const res = await getPostData('lstSkills/GetSingleData_Skills', val)
    dispatch({ type: SkillsListSingle_Data, payload: res });
};

export const get_LanguagesList = (IsActive, setLoading) => async (dispatch) => {
    setLoading(true);
    const val = { 'IsActive': IsActive }
    const res = await getPostData('lstLanguages/GetData_Languages', val)
    dispatch({ type: LanguagesList_Data, payload: res });
    setLoading(false);
};

export const get_LanguagesListDataSingleData = (LanguagesID) => async (dispatch) => {
    const val = { 'LanguagesID': LanguagesID }
    const res = await getPostData('lstLanguages/GetSingleData_Languages', val)
    dispatch({ type: LanguagesListSingle_Data, payload: res });
};


export const get_Authorname = (IsActive, setLoading) => async (dispatch) => {
    setLoading(true);
    const val = { 'IsActive': IsActive }
    const res = await getPostData('BlogAuthorName/GetData_BlogAuthorName', val)
    dispatch({ type: AuthorName, payload: res });
    setLoading(false);
};

export const get_AuthorSingleData = (AuthorId) => async (dispatch) => {
    const val = { 'AuthorId': AuthorId }
    const res = await getPostData('BlogAuthorName/GetSingleData_BlogAuthorName', val)
    dispatch({ type: AuthorNameSingle_Data, payload: res });
};






export const get_BlogCategory = (IsActive, setLoading) => async (dispatch) => {
    setLoading(true);
    const val = { 'IsActive': IsActive }
    const res = await getPostData('BlogCategory/GetData_BlogCategory', val)
    dispatch({ type: BlogCategory_Data, payload: res });
    setLoading(false);
};

export const get_BlogCategorySingleData = (BlogCategoryID) => async (dispatch) => {
    const val = { 'BlogCategoryID': BlogCategoryID }
    const res = await getPostData('BlogCategory/GetSingleData_BlogCategory', val)
    dispatch({ type: BlogCategorySingle_Data, payload: res });
};



export const get_BlogData = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('Blog/GetData_Blog', val)
    dispatch({ type: Blog_Data, payload: res });
    setloading(false)
};


export const get_BlogSingleData = (BlogID) => async (dispatch) => {
    const val = { 'BlogID': BlogID }
    const res = await getPostData('Blog/GetSingleData_Blog', val)
    dispatch({ type: BlogSingle_Data, payload: res });
};

export const get_BlogCategoryDrp = () => async (dispatch) => {
    const res = await getData('Blog/GetDropDownData_Blog');
    if (Array.isArray(res)) {

        const formattedData = res.map(item => {
            return {
                value: item.BlogCategoryID, label: item.Description
            };
        });
        dispatch({ type: BlogCategoryDrp_Data, payload: formattedData });
    } else {
        dispatch({ type: BlogCategoryDrp_Data, payload: [] });
    }
};

export const get_DregeeDiplomaData = (IsActive, setLoading) => async (dispatch) => {
    setLoading(true);
    const val = { 'IsActive': IsActive }
    const res = await getPostData('DregeeDiploma/GetData_DregeeDiploma', val)
    dispatch({ type: DregeeDiploma_Data, payload: res });
    setLoading(false);
};


export const get_DregeeDiplomaSingleData = (DregeeID) => async (dispatch) => {
    const val = { 'DregeeID': DregeeID }
    const res = await getPostData('DregeeDiploma/GetSingleData_DregeeDiploma', val)
    dispatch({ type: DregeeDiplomaSingle_Data, payload: res });
};

export const get_LanguagesData = (IsActive) => async (dispatch) => {
    const val = { 'IsActive': IsActive }
    const res = await getPostData('lstLanguages/GetData_Languages', val);
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.LanguagesID, label: item.Description
            };
        });
        dispatch({ type: Languages_Data, payload: formattedData });
    } else {
        dispatch({ type: Languages_Data, payload: [] });
    }
};

export const get_SkillData = (IsActive) => async (dispatch) => {
    const val = { 'IsActive': IsActive }
    const res = await getPostData('lstSkills/GetData_Skills', val);
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.SkillsID, label: item.Description
            };
        });
        dispatch({ type: Skills_Data, payload: formattedData });
    } else {
        dispatch({ type: Skills_Data, payload: [] });
    }
};

export const get_CategoryData = (IsActive) => async (dispatch) => {
    const val = { 'IsActive': IsActive }
    const res = await getData('AstrologersCategory/GetDropDownData_AstrologersCategory');
  
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.CategoryID, label: item.Description
            };
        });
        dispatch({ type: Categorys_Data, payload: formattedData });
    } else {
        dispatch({ type: Categorys_Data, payload: [] });
    }
};


export const get_AstrologersCategoryData = (IsActive, setLoading) => async (dispatch) => {
    setLoading(true);
    const val = { 'IsActive': IsActive }
    const res = await getPostData('AstrologersCategory/GetData_AstrologersCategory', val)
    dispatch({ type: AstrologersCategory_Data, payload: res });
    setLoading(false);
};


export const get_AstrologersCategorySingleData = (CategoryID) => async (dispatch) => {
    const val = { 'CategoryID': CategoryID }
    const res = await getPostData('AstrologersCategory/GetSingleData_AstrologersCategory', val)
    dispatch({ type: AstrologersCategorySingle_Data, payload: res });
};



export const get_PrivacyPolicyData = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('PrivacyPolicy/GetData_PrivacyPolicy', val)
    dispatch({ type: PrivacyPolicy_Data, payload: res });
    setloading(false)
};


export const get_PrivacyPolicySingleData = (PrivacyPolicyID) => async (dispatch) => {
    const val = { 'PrivacyPolicyID': PrivacyPolicyID }
    const res = await getPostData('PrivacyPolicy/GetSingleData_PrivacyPolicy', val)
    dispatch({ type: PrivacyPolicySingle_Data, payload: res });
};

export const get_PrivacyPolicyDrp = (IsActive) => async (dispatch) => {
    const res = await getData('PrivacyPolicy/GetDropDownData_PrivacyPolicy',);
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.Category, label: item.Category
            };
        });
        dispatch({ type: PrivacyPolicyDrop_Data, payload: formattedData });
    } else {
        dispatch({ type: PrivacyPolicyDrop_Data, payload: [] });
    }
};



export const get_MuhuratData = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('Muhurat/GetData_Muhurat', val)
    dispatch({ type: GetData_Muhurat, payload: res });
    setloading(false)
};


export const get_MuhuratSingleData = (MuhuratID) => async (dispatch) => {
    const val = { 'MuhuratID': MuhuratID }
    const res = await getPostData('Muhurat/GetSinglaData_Muhurat', val)
    dispatch({ type: GetSinglaData_Muhurat, payload: res });
};



export const get_MuhuratDrp = (IsActive) => async (dispatch) => {
    const res = await getData('Muhurat/GetDropDwonData_Muhurat',);

    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.MuhuratID, label: item.Description
            };
        });

        dispatch({ type: GetDropDwonData_Muhurat, payload: formattedData });
    } else {
        dispatch({ type: GetDropDwonData_Muhurat, payload: [] });
    }

};


export const get_MainMuhuratData = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('MuhuratMain/GetData_Muhurat', val)
    dispatch({ type: GetData_MainMuhurat, payload: res });
    setloading(false)
};

export const get_MainMuhuratSingleData = (ID) => async (dispatch) => {
    const val = { 'ID': ID }
    const res = await getPostData('MuhuratMain/GetSinglaData_Muhurat', val)

    dispatch({ type: GetSinglaData_MainMuhurat, payload: res });
};



export const get_CategoryNotification = (IsActive, setLoading) => async (dispatch) => {
    setLoading(true)
    const val = { 'IsActive': IsActive };
    const res = await getPostData('PushNotificationCategory/GetData_PushNotificationCategory', val);
    dispatch({ type: CategoryNotification_Data, payload: res });
    setLoading(false)
};

export const get_CategoryNotification_Single_Data = (PushNotificationCategoryID) => async (dispatch) => {
    const val = { 'PushNotificationCategoryID': PushNotificationCategoryID }
    const res = await getPostData('PushNotificationCategory/GetSinglaData_PushNotificationCategory', val)
    dispatch({ type: CategoryNotification_Single_Data, payload: res });
}


export const get_CategoryRedirect = (IsActive, setLoading) => async (dispatch) => {
   
    const val = { 'IsActive': IsActive };
    const res = await getPostData('NotificationRedirect/GetData_NotificationRedirect',val);
   
    dispatch({ type: CategoryRedirect, payload: res });
   
};

export const get_CategoryRedirect_Single_Data = (ID) => async (dispatch) => {
    const val = { 'Id':ID  }
    const res = await getPostData('NotificationRedirect/GetSinglaData_NotificationRedirect', val)
   
    dispatch({ type: CategoryRedirectsingle, payload: res });
}


export const get_DataNotification = (IsActive, setLoading) => async (dispatch) => {
    setLoading(true)
    const val = { 'IsActive': IsActive };
    const res = await getPostData('PushNotification/GetData_PushNotification', val)

    dispatch({ type: DataNotification_Data, payload: res });
    setLoading(false)
}

export const get_PushCategorySingleData = (PushNotificationID) => async (dispatch) => {
    const val = { 'PushNotificationID': PushNotificationID };
    const res = await getPostData('PushNotification/GetSinleData_PushNotification', val);
    dispatch({ type: PushCategory_Single_Data, payload: res });
}



export const get_Notification_rule = (setLoading) => async (dispatch) => {
    setLoading(true)
    const val = {NotificationId:null};
   
    const res = await getPostData('NotificationSegments/GetData_Notification',val)
    dispatch({ type: GetData_NotificationRule, payload: res });
    setLoading(false)
}
export const get_Notification_Condition = (setLoading) => async (dispatch) => {
    setLoading(true)
    const val = {IsActive:1};
    
    const res = await getPostData('NotificationCondition/GetData_NotificationCondition',val)
    
    dispatch({ type: CategoryCondition, payload: res });
    setLoading(false)
}

export const get_Single_Notification_rule = (Id, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'NotificationId': Id };
    const res = await getPostData('NotificationSegments/GetData_Notification', val);
    dispatch({ type: GetSinglaData_NotificationRule, payload: res });
    setloading(false)
}






export const get_PushCategoryDrp = () => async (dispatch) => {
    const res = await getData('PushNotificationCategory/GetDropDownData_PushNotificationCategory');
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.PushNotificationCategoryID, label: item.Category
            };
        });
        dispatch({ type: SET_DROPDOWN_DATA, payload: formattedData });
    } else {
        dispatch({ type: SET_DROPDOWN_DATA, payload: [] });
    }
};



export const get_Pooja_Data = (IsActive, setLoading) => async (dispatch) => {
    setLoading(true)
    const val = { 'IsActive': IsActive };
    const res = await getPostData('PujaFor/GetData_PujaFor', val)
    dispatch({ type: Pooja_Data, payload: res });
    setLoading(false)
}

export const get_Pooja_Single_Data = (PujaForID) => async (dispatch) => {
    const val = { 'PujaForID': PujaForID };
    const res = await getPostData('PujaFor/GetsinglaData_PujaFor', val)
    dispatch({ type: Pooja_Single_Data, payload: res });
}


export const get_Puja_Data_Puja = (IsActive) => async (dispatch) => {
    const val = { 'IsActive': IsActive };
    const res = await getPostData('Puja/GetData_Puja', val)
    dispatch({ type: Puja_Get_Data_Puja, payload: res });
}

export const get_PujaFor_GetDropDownData_PujaFor = () => async (dispatch) => {
    const res = await getData('PujaFor/GetDropDownData_PujaFor');
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.PujaForID, label: item.PujaFors
            };
        });
        dispatch({ type: PujaFor_GetDropDownData_PujaFor, payload: formattedData });
    } else {
        dispatch({ type: PujaFor_GetDropDownData_PujaFor, payload: [] });
    }
};

export const get_Puja_GetSinglaData_Puja = (PujaID) => async (dispatch) => {
    const val = { 'PujaID': PujaID };
    const res = await getPostData('Puja/GetSinglaData_Puja', val)
    dispatch({ type: Puja_GetSinglaData_Puja, payload: res });
}
export const get_Gemstone_Category_data = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('GemstoneCategory/GetData_GemstoneCategory', val)
    dispatch({ type: Gemstone_Category_data, payload: res });
    setloading(false)
};

export const get_Gemstone_CategorySingledata = (GemstoneCategoryID) => async (dispatch) => {
    const val = { 'GemstoneCategoryID': GemstoneCategoryID }
    const res = await getPostData('GemstoneCategory/GetSinglaData_GemstoneCategory', val)
    dispatch({ type: GemstoneCategory_Singledata, payload: res });
};

export const get_Gemstone_GetData_GemData = (IsActive) => async (dispatch) => {
    const val = { 'IsActive': IsActive }
    const res = await getPostData('Gemstone/GetData_Gemstone', val)
    dispatch({ type: Gemstone_GetData_GemData, payload: res });
};

export const get_GemstoneCategory_GetDropDawnData = () => async (dispatch) => {
    const res = await getData('GemstoneCategory/GetDropDawnData_GemstoneCategory');
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.GemstoneCategoryID, label: item.Category
            };
        });
        dispatch({ type: GemstoneCategory_GetDropDawnData, payload: formattedData });
    } else {
        dispatch({ type: GemstoneCategory_GetDropDawnData, payload: [] });
    }
};

export const get_Gemstone_Singledata = (GemstoneID) => async (dispatch) => {
    const val = { 'GemstoneID': GemstoneID }
    const res = await getPostData('Gemstone/GetSinglaData_Gemstone', val)
    dispatch({ type: Gemstone_Singledata, payload: res });
};

export const get_Gemstione_User = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('GemstoneOrder/GetData_GemstoneOrder', val)
    dispatch({ type: Gemstone_User, payload: res });
    setloading(false)
}

export const get_Gemstione_Cart = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('Cart/GetData_Cart', val)
    dispatch({ type: Gemstone_Cart_List, payload: res });
    setloading(false)
}
export const get_SinglaData_GemstoneOrder = (GemstoneOrderID) => async (dispatch) => {
    const val = { 'GemstoneOrderID': GemstoneOrderID };
    const res = await getPostData('GemstoneOrder/GetSinglaData_GemstoneOrder', val)
    if (!res) {
    }
    dispatch({ type: SinglaData_GemstoneOrder, payload: res });
}

export const get_CallHistory = (data) => async (dispatch) => {
    try {
        const res = await getPostData('Astrologer/CallHistory', data);
        dispatch({ type: Call_History, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};

export const get_AstroDrp = (IsActive) => async (dispatch) => {
    const val = { 'IsActive': IsActive }
    const res = await getPostData('Astrologer/GetData_Astrologer', val);
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.ID, label: item.RegMobileNo
            };
        });
        dispatch({ type: SET_DROPDOWN_ASTRO, payload: formattedData });

    } else {
        dispatch({ type: SET_DROPDOWN_ASTRO, payload: [] });
    }
};

export const call_chart_data = (data) => async (dispatch) => {

    try {
        const res = await getPostData('HomePage/CallAccDay', data);


        dispatch({ type: CAll_CHART_DATA, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};

export const user_Status_data = (data) => async (dispatch) => {

    try {
        const res = await getPostData('HomePage/UserStatus', data);


        dispatch({ type: User_Status, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};

export const total_Astrologer_data = (data) => async (dispatch) => {

    try {
        const res = await getPostData('HomePage/AstrologerStatus', data);


        dispatch({ type: Total_Astrologer, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};

export const chat_Data = (data) => async (dispatch) => {

    try {
        const res = await getPostData('HomePage/ChatStatus', data);


        dispatch({ type: Chat_Chart, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};

export const Gemstone_Revenues = (data) => async (dispatch) => {

    try {
        const res = await getPostData('HomePage/GemStoneRevenue', data);


        dispatch({ type: Gemstone_Revenue, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};
export const Pooja_Revenues = (data) => async (dispatch) => {

    try {
        const res = await getPostData('HomePage/PoojaRevenue', data);


        dispatch({ type: Pooja_Revenue, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};

export const Call_Revenues = (data) => async (dispatch) => {

    try {
        const res = await getPostData('HomePage/CallRevenue', data);


        dispatch({ type: Call_Revenue, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};




export const get_Home_Page_Count = (start,end) => async (dispatch) => {
    try {
        const value={"FromDate":start,"Todate":end }
        const res = await getPostData('HomePage/HomeCount',value);

        dispatch({ type: Home_Page_Count, payload: res });

    } catch (error) {
        console.error('Error in get_Home_Page_Count:', error);
    }
};

export const get_Chat_Acc_Day = () => async (dispatch) => {
    try {
        const res = await getPostData('HomePage/ChatAccDay');
        dispatch({ type: Chat_Acc_Day, payload: res });
    }
    catch
    (error) {
        console.error('Error in get_Home_Page_Count:', error);
    }
}
export const get_Astro_Filter = (FromDate, Todate) => async (dispatch) => {
    const val = { FromDate, Todate };
    const res = await getPostData('HomePage/AstrologerData', val);


    dispatch({ type: Astro_Filter, payload: res });
};

export const get_User_Filter = (FromDate, Todate) => async (dispatch) => {
    const val = { FromDate, Todate };
    const res = await getPostData('HomePage/UsersData', val)

    dispatch({ type: User_Filter, payload: res });

}


const ENCRYPTION_KEY = "9z$C&F)J@NcRfTjW";
const ENCRYPTION_IV = "ABCDEFGH";


export const encrypt = (plainText) => {
    try {
        const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);
        const iv = CryptoJS.enc.Utf8.parse(ENCRYPTION_IV);

        const encrypted = CryptoJS.TripleDES.encrypt(
            plainText,
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        );
        return encrypted.toString();
    } catch (error) {
        console.error("Encryption Error:", error);
        return null;
    }
};
export const get_Expense_Category = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive };
    const res = await getPostData('ExpenseCategory/GetData_ExpenseCategory', val)
    dispatch({ type: Expense_Category, payload: res });
    setloading(false)
}

export const get_Single_Expense_Category = (ExpenseCategoryID) => async (dispatch) => {
    const val = { 'ExpenseCategoryID': ExpenseCategoryID };
    const res = await getPostData('ExpenseCategory/GetSingleData_ExpenseCategory', val)
    dispatch({ type: Single_Expense_Category, payload: res });
}


export const get_Insert_ExpenseCategory = (Category, IsActive, ApiSecretkey, ApiKey, Password, UserID, Url, Notes) => async (dispatch) => {
    try {

        const encryptedCategory = encrypt(JSON.stringify(Category));
        const encryptedIsActive = encrypt(JSON.stringify(IsActive));
        const encryptedSecretkey = encrypt(JSON.stringify(ApiSecretkey));
        const encryptedkey = encrypt(JSON.stringify(ApiKey));
        const encryptedpassword = encrypt(JSON.stringify(Password));
        const encryptedname = encrypt(JSON.stringify(UserID));
        const encryptedurl = encrypt(JSON.stringify(Url));
        const encryptedNotes = encrypt(JSON.stringify(Notes));


        const res = await getPostData('ExpenseCategory/Insert_ExpenseCategory', {

            Category: encryptedCategory,
            IsActive: encryptedIsActive,
            ApiSecretkey: encryptedSecretkey,
            ApiKey: encryptedkey,
            Password: encryptedpassword,
            UserID: encryptedname,
            Url: encryptedurl,
            Notes: encryptedNotes,
        });

        if (res) {
            dispatch({ type: Insert_ExpenseCategory, payload: (res) });
        } else {
            console.warn('No data in response:', res);
        }
    } catch (error) {
        console.error('Error in get_Insert_ExpenseCategory:', error);
    }
};


export const get_Update_ExpenseCategory = (ExpenseCategoryID, Category, IsActive, ApiSecretkey, ApiKey, Password, UserID, Url, Notes) => async (dispatch) => {
    try {

        const encryptedCategory = encrypt(JSON.stringify(Category));
        const encryptedIsActive = encrypt(JSON.stringify(IsActive));
        const encryptedSecretkey = encrypt(JSON.stringify(ApiSecretkey));
        const encryptedkey = encrypt(JSON.stringify(ApiKey));
        const encryptedpassword = encrypt(JSON.stringify(Password));
        const encryptedname = encrypt(JSON.stringify(UserID));
        const encryptedurl = encrypt(JSON.stringify(Url));
        const encryptedNotes = encrypt(JSON.stringify(Notes));

        const res = await getPostData('ExpenseCategory/Update_ExpenseCategory', {

            ExpenseCategoryID: ExpenseCategoryID,
            Category: encryptedCategory,
            IsActive: encryptedIsActive,
            ApiSecretkey: encryptedSecretkey,
            ApiKey: encryptedkey,
            Password: encryptedpassword,
            UserID: encryptedname,
            Url: encryptedurl,
            Notes: encryptedNotes,
        });


        if (res) {


            dispatch({ type: Update_ExpenseCategory, payload: (res) });
        } else {
            console.warn('No data in response:', res);
        }
    } catch (error) {
        console.error('Error in get_Update_ExpenseCategory:', error);
    }
};


export const get_Expense_Details = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive };
    const res = await getPostData('Expensedetails/GetData_Expensedetails', val)
    dispatch({ type: Expense_Details, payload: res });
    setloading(false)
}
export const get_Single_Expense_Details = (ExpensedetailsID) => async (dispatch) => {
    const val = { 'ExpensedetailsID': ExpensedetailsID };


    const res = await getPostData('Expensedetails/GetSinglaData_Expensedetails', val)
    dispatch({ type: Single_Expense_Details, payload: res });
}

export const get_Insert_ExpenseDetails = (newCustomerStory) => async (dispatch) => {

    const res = await getPostData('Expensedetails/Insert_Expensedetails', newCustomerStory)
    dispatch({ type: Insert_Expense_Details, payload: res });
}

export const get_Update_ExpenseDetails = (ExpenseID, IsActive, Amount, CurrentDate, RenewDate, ModifiedByUser, ExpensedetailsID) => async (dispatch) => {
    try {

        const val = { ExpenseID: ExpenseID, IsActive: IsActive, Amount: Amount, CurrentDate: CurrentDate, RenewDate: RenewDate, ModifiedByUser: ModifiedByUser, ExpensedetailsID: ExpensedetailsID }


        const res = await getPostData('Expensedetails/Update_Expensedetails', val);


        if (res) {
            dispatch({ type: Update_Expense_Details, payload: (res) });
        } else {
            console.warn('No data in response:', res);
        }
    } catch (error) {
        console.error('Error in get_Insert_ExpenseDetails:', error);
    }
};

export const get_Dropdown_Category = () => async (dispatch) => {

    try {
        const res = await getData('ExpenseCategory/GetDropDownData_ExpenseCategory');

        dispatch({ type: GetDropDownData_ExpenseCategory, payload: res });

    } catch (error) {

    }
}



export const get_Transaction_Category = (IsActive, setLoading) => async (dispatch) => {
    setLoading(true)
    const val = { 'IsActive': IsActive };
    const res = await getPostData('TransactionCategory/GetData_TransactionCategory', val)
    dispatch({ type: GetData_TransactionCategory, payload: res });
    setLoading(false)
}

export const get_Single_Transaction_Category = (ID) => async (dispatch) => {

    const val = { 'ID': ID };
    const res = await getPostData('TransactionCategory/GetSingleData_TransactionCategory', val)
    dispatch({ type: GetSingleData_TransactionCategory, payload: res });

}
export const get_Dropdown_Transaction_Category = () => async (dispatch) => {

    try {
        const res = await getData('TransactionCategory/GetDropDownData_TransactionCategory');

        if (Array.isArray(res)) {
            const formattedData = res.map(item => {
                return {
                    value: item.ID, label: item.Category
                };
            });

            dispatch({ type: GetDropDownData_TransactionCategory, payload: formattedData });
        } else {
            dispatch({ type: GetDropDownData_TransactionCategory, payload: [] });
        }

    } catch (error) {

    }
}


export const get_Company_Transaction = (setLoading, IsActive, TransactionDateFrom, TransactionDateTo, TransactionType) => async (dispatch) => {
    setLoading(true)
    const val = { 'IsActive': IsActive, "TransactionDateFrom": TransactionDateFrom, "TransactionDateTo": TransactionDateTo, "TransactionType": TransactionType };
    const res = await getPostData('CompanyTransaction/GetData_CompanyTransaction', val)
    dispatch({ type: GetData_CompanyTransaction, payload: res });
    setLoading(false)
}
export const get_Single_CompanyTransaction = (ID) => async (dispatch) => {

    const val = { 'ID': ID };
    const res = await getPostData('CompanyTransaction/GetSingleData_CompanyTransaction', val)
    dispatch({ type: GetSingleData_CompanyTransaction, payload: res });

}

export const get_Single_NewCompany = (ID, setLoading) => async (dispatch) => {
    setLoading(true)
    const val = { 'CompanyID': ID };
    const res = await getPostData('CompanyTransaction/GetsinglaData_Company', val)
    dispatch({ type: GetsinglaData_Company, payload: res });
    setLoading(false)

}
export const get_NewCompany = (ID, setLoading) => async (dispatch) => {
    setLoading(true)
    const val = { 'CompanyID': ID };
    const res = await getPostData('CompanyTransaction/GetData_Company', val)
    dispatch({ type: GetData_Company, payload: res });
    setLoading(false)

}

export const get_Company_Header_Transaction = (IsActive, TransactionDateFrom, TransactionDateTo) => async (dispatch) => {
  
    const val = { 'IsActive': IsActive, "TransactionDateFrom": TransactionDateFrom, "TransactionDateTo": TransactionDateTo };
    const res = await getPostData('CompanyTransaction/GetData_headerCompanyTransaction', val)
    dispatch({ type: GetData_headerCompanyTransaction, payload: res });
    
}

export const get_Payment_History = (FromDate, Todate, UserID, setloading) => async (dispatch) => {
    setloading(true)
    const val = { FromDate, Todate, UserID };
    const res = await getPostData('HomePage/GetData_PaymentHistory', val)
    dispatch({ type: GetData_PaymentHistory, payload: res });
    setloading(false)
}
export const get_Astrologer_Price_Change = (setloading, CreatedDateFrom, CreatedDateTo, AstroId) => async (dispatch) => {
    setloading(true)
    const val = { CreatedDateFrom: CreatedDateFrom, CreatedDateTo: CreatedDateTo };
    const res = await getPostData('PaymentchangeRequest/GetData_PaymentchangeRequest', val)
    dispatch({ type: GetData_PaymentchangeRequest, payload: res });
    setloading(false)
}

export const get_Payment_page_visitors = (CreatedDtTm, CreatedDtTmTo, setloading) => async (dispatch) => {
    setloading(true)
    const val = { CreatedDtTm, CreatedDtTmTo };
    const res = await getPostData('HomePage/GetData_Paymentbutnotbuy', val)
    dispatch({ type: GetData_Paymentbutnotbuy, payload: res });
    setloading(false)
}

export const get_UserWallet_Transaction = (FromDate, Todate, UserID, setloading) => async (dispatch) => {
    setloading(true)
    const val = { FromDate, Todate, NickName:UserID,UserID:"" };
    const res = await getPostData('HomePage/GetData_UserWalletTransaction', val)
    dispatch({ type: GetData_UserWalletTransaction, payload: res });
    setloading(false)
}

export const get_AstroWallet_Transaction = (TransactionDateFrom, TransactionDateTo, AstroID,Category, setloading) => async (dispatch) => {
    setloading(true)
    const val = { TransactionDateFrom, TransactionDateTo, AstroID ,Category};
    const res = await getPostData('AstroWalletTransaction/GetData_AstroWalletTransaction', val)
    dispatch({ type: GetData_AstroWalletTransaction, payload: res });
    setloading(false)
}

export const get_AstroSallary_Transaction = (TransactionDateFrom, TransactionDateTo, AstroID, setloading) => async (dispatch) => {
    setloading(true)
    const val = { TransactionDateFrom, TransactionDateTo,AstroID};
    const res = await getPostData('AstroWalletTransaction/AstroTransactionSalary', val)
    dispatch({ type: GetData_AstroSallaryTransaction, payload: res });
    setloading(false)
}

export const get_Chat_Filter = (Datetimefrom, Datetimeto, AstrologerName, UserName, UserMobileNo, AstroRegMobileNo, setloading) => async (dispatch) => {
    setloading(true)
    const val = {"IsActive": "1",
  "Type": "chat",  Datetimefrom, Datetimeto, AstrologerName, UserName, UserMobileNo, AstroRegMobileNo };
    const res = await getPostData('ChatHistory/GetData_ChatHistory', val)
   
    dispatch({ type: Chat_Filter, payload: res });
    setloading(false)

}

export const get_Chat_message_history = (AstroID, UserID, chatOrderId, setloading) => async (dispatch) => {
    setloading(true)
    const val = { AstroID, UserID, chatOrderId };
    const res = await getPostData('Chat/ReturnChat', val)
    dispatch({ type: Chat_Message, payload: res });
    setloading(false)

}

export const get_Chat_analyzises = (AstroId,UserId,ChatId,DateFrom,DateTo,AstroIds,UserIds) => async (dispatch) => {
    
    const val = {AstroId:AstroId,UserId:UserId,ChatId:ChatId,DateFrom:DateFrom,DateTo:DateTo, AstroName:AstroIds,UserName:UserIds };
    const res = await getPostData('ChatAnalysisReport/GetData_ChatAnalysisReport', val)
    dispatch({ type: GetData_ChatAnalysisReport, payload: res });
   

}



export const get_not_login_user = (LastDay, setloading) => async (dispatch) => {
    setloading(true)
    const val = { LastDay: LastDay,UserType:"" }
    const res = await getPostData("User/GetData_UserNotUsed", val)
    dispatch({ type: GetData_UserNotUsed, payload: res })
    setloading(false)
}
export const get_single_not_login_user = (ID) => async (dispatch) => {
    const val = { ID: ID }
    const res = await getPostData('PaymentchangeRequest/GetSinglaData_PaymentchangeRequest', val)
    dispatch({ type: GetSinglaData_PaymentchangeRequest, payload: res })
}

export const get_AstroGallary = (CreatedDtTm, CreatedDtTmTo, IsActive, IsVerify, DisplayName, RegMobileNo, setLoading) => async (dispatch) => {
    setLoading(true)
    const val = { 'IsActive': IsActive, IsVerify: IsVerify, "CreatedDtTm": CreatedDtTm, "CreatedDtTmTo": CreatedDtTmTo, "DisplayName": DisplayName, "RegMobileNo": RegMobileNo };
    const res = await getPostData('AstrologerGallery/GetData_AstrologerGallery', val)
    dispatch({ type: GetData_AstrologerGallery, payload: res });
    setLoading(false)
}

export const get_Single_AstroGallary = (AstroId, IsVerify, setLoading) => async (dispatch) => {
    
    const val = { 'AstroId': AstroId, "IsActive": 1 };
    const res = await getPostData('AstrologerGallery/GetSinglaData_AstrologerGallery', val)
    dispatch({ type: GetSinglaData_AstrologerGallery, payload: res });
    

}


export const Online_Puja_Filters = (CreatedFrom, CreatedTo, OrderStatus, isActive) => async (dispatch) => {
    const val = { CreatedFrom, CreatedTo, OrderStatus, IsActive: isActive };

    const res = await getPostData('BookingPuja/GetData_BookingPuja', val)
    dispatch({ type: Online_Puja_Filter, payload: res });

}


export const Gemstone_Filters = (CreatedFrom, CreatedTo, PaymentStatus, IsActive, setLoading) => async (dispatch) => {
    setLoading(true)
    const val = { CreatedFrom, CreatedTo, PaymentStatus, IsActive: IsActive };

    const res = await getPostData('GemstoneOrder/GetData_GemstoneOrder', val)
    dispatch({ type: Gemstone_Filter, payload: res });
    setLoading(false)

}

export const Call_Filters = (FromDate, Todate, AstroName, AstroPhone, UserName, UserPhone, setLoading) => async (dispatch) => {
    setLoading(true)
    const val = { "IsActive": "1",
  "Type": "call", 

      Datetimefrom:FromDate, Datetimeto:Todate, AstrologerName:AstroName, AstroRegMobileNo:AstroPhone, UserName:UserName, UserMobileNo: UserPhone, AstroID:"", UserID:""   
};
    
    const res = await getPostData('ChatHistory/GetData_ChatHistory', val)
    dispatch({ type: Call_Filter, payload: res });
    setLoading(false)

}

export const UserInsert = (data) => async (dispatch) => {

    try {
        const res = await getPostData('Users/UsersInsert', data);


        dispatch({ type: User_Insert, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};


export const get_User_data = (setloading, IsActive) => async (dispatch) => {
  
    const val = { 'IsActive': IsActive };
    const res = await getPostData('Users/GetData_Users', val)
    dispatch({ type: GetData_Users, payload: res });
    
}

export const get_AdminSingleData = (AdminID) => async (dispatch) => {
    const val = { 'Id': AdminID }
    const res = await getPostData('Users/GetData_SingleData', val)
    dispatch({ type: AdminSingle_Data, payload: res });
};

export const UserUpdate = (data) => async (dispatch) => {

    try {
        const res = await getPostData('Users/UsersUpdate', data);


        dispatch({ type: User_Insert, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};

export const UserUpdateImage = (data) => async (dispatch) => {

    try {
        const res = await getPostData('Users/UsersPhotoUpdate', data);


        dispatch({ type: User_Insert, payload: res });
    } catch (error) {
        console.error('Error fetching call history:', error);
    }
};



export const get_VratUpvaasData = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('VratUpvaas/GetData_VratUpvaas', val)
    dispatch({ type: GetData_VratUpvaas, payload: res });
    setloading(false)
};


export const get_VratUpvaasSingleData = (VratUpvaasID) => async (dispatch) => {
    const val = { 'VratUpvaasID': VratUpvaasID }
    const res = await getPostData('VratUpvaas/GetSinglaData_VratUpvaas', val)
    dispatch({ type: GetSinglaData_VratUpvaas, payload: res });
};


export const get_VratUpvaasDrp = (IsActive) => async (dispatch) => {
    const res = await getData('VratUpvaas/GetDropDwonData_VratUpvaas',);
    if (Array.isArray(res)) {
        const formattedData = res.map(item => {
            return {
                value: item.VratUpvaasID, label: item.Description
            };
        });

        dispatch({ type: GetDropDwonData_MainVratUpvaas, payload: formattedData });
    } else {
        dispatch({ type: GetDropDwonData_MainVratUpvaas, payload: [] });
    }

};


export const get_MainVratUpvaasData = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive }
    const res = await getPostData('VratUpvaasMain/GetData_VratUpvaasMain', val)
    dispatch({ type: GetData_MainVratUpvaas, payload: res });
    setloading(false)
};

export const get_MainVratUpvaasSingleData = (ID) => async (dispatch) => {
    const val = { 'ID': ID }
    const res = await getPostData('VratUpvaasMain/GetSinglaData_VratUpvaasMain', val)

    dispatch({ type: GetSinglaData_MainVratUpvaas, payload: res });
};


export const get_Income_Category = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive };
    const res = await getPostData('IncomeCategory/GetData_IncomeCategory', val)
    dispatch({ type: Income_Category, payload: res });
    setloading(false)
}

export const get_SinglaData_IncomeCategory = (IncomeCategoryID) => async (dispatch) => {
    const val = { 'IncomeCategoryID': IncomeCategoryID };
    const res = await getPostData('IncomeCategory/GetSinglaData_IncomeCategory', val)
    dispatch({ type: SinglaData_IncomeCategory, payload: res });
}
export const get_Ticket_Category = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { 'IsActive': IsActive };
    const res = await getPostData('TicketCategory/GetData_TicketCategory', val)
    dispatch({ type: Ticket_Category, payload: res });
    setloading(false)
}
export const get_SinglaData_Ticket_Category = (TicketCategoryID) => async (dispatch) => {
    const val = { 'TicketCategoryID': TicketCategoryID };
    const res = await getPostData('TicketCategory/GetSinglaData_TicketCategory', val);
    dispatch({ type: SinglaData_Ticket_Category, payload: res });
}
export const get_data_Review_Data = (setLoading, IsActive, CreatedDtTm, CreatedDtTmTo, AstroName, UserName) => async (dispatch) => {
    setLoading(true)
    const val = { IsActive: IsActive, CreatedDtTmFrom: CreatedDtTm, CreatedDtTmTo: CreatedDtTmTo, AstroName: AstroName, UserName: UserName };
    const res = await getPostData("Feedback/GetData_Feedback", val);
    dispatch({ type: GetData_Feedback, payload: res });
    setLoading(false)
}
export const get_Single_Review_Data = (FeedbackID) => async (dispatch) => {
    const val = { FeedbackID: FeedbackID };
    const res = await getPostData("Feedback/GetSingleData_Feedback", val);
    dispatch({ type: GetSingleData_Feedback, payload: res });
}
export const get_Festival = (IsActive, setloading) => async (dispatch) => {
    setloading(true)
    const val = { IsActive: IsActive };
    const res = await getPostData("Festival/GetData_Festival", val);
    dispatch({ type: GetData_Festival, payload: res });
    setloading(false)

}
export const get_Single_Festival = (FestivalID) => async (dispatch) => {

    const val = { FestivalID: FestivalID };
    const res = await getPostData("Festival/GetSinglaData_Festival", val)
    dispatch({ type: GetSinglaData_Festival, payload: res });

}
export const get_Expeses = (IsActive, setloading) => async (dispatch) => {
   
    const val = { IsActive: IsActive };
    const res = await getPostData("Expense/GetData_Expense", val);
    dispatch({ type: GetData_Expense, payload: res });
   

}
export const get_Single_Expenses = (ExpenseID) => async (dispatch) => {

    const val = { ExpenseID: ExpenseID };
    const res = await getPostData("Expense/GetSinglaData_Expense", val)
    dispatch({ type: GetSinglaData_Expense, payload: res });

}
export const get_wallet_packagename=(IsActive)=>async(dispatch)=>{
    const val={IsActive:IsActive};
    const res =await getPostData("WalletPlanName/GetData_WalletPlanName",val)
    dispatch({type:GetData_WalletPlanName,payload:res});
}
export const get_single_wallet_packagename=(id)=> async(dispatch)=>{
    const val={PlanId:id}
    const res=await getPostData("WalletPlanName/GetsinglaData_WalletPlanName",val)
    dispatch({type:GetsinglaData_WalletPlanName,payload:res})
}

